export enum enumSasClassification {
  'Gold' = 1,
  'Silver',
  'All',
  'Blue',
}

export namespace enumSasClassification {
  export function values() {
    return Object.keys(enumSasClassification).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
